import React from "react";

const WlfAttempt = (props) => {
    let teamAthletes = props?.data?.teamAthletes
    let athlete = teamAthletes?.find(row => row.order === 0)
    let eventUnitEntries = athlete?.eventUnitEntries?.find(row => row.eue_code === props?.code + '_ATTEMPT')?.eue_value

    let extendedResults = props?.data?.extendedResults?.find(row => row.er_code === props?.code && row.er_pos === props?.pos)?.er_value
    let attemp = props?.data?.extendedResults?.find(row => row.er_code === props?.code && row.er_pos === props?.pos)?.er_value2
    let out;

    if (props?.pos === '1' && !extendedResults) {
        out = eventUnitEntries
    } else {
        if (attemp === 'N') {
            out = <span className="text-danger">{extendedResults}</span>
        } else if (attemp === 'Y') {
            out = <span className="text-success">{extendedResults}</span>
        } else {
            out = extendedResults
        }
    }
    return (
        <>{out}</>
    )
};

export default WlfAttempt;